import axios from "axios"
import {configuration} from "../../appConfig"
import partnerConfigs from '../../../src/screens/DAT/userDAT.json';
var convert = require("xml-js");

// axios.defaults.headers.common['X-Auth-Token'] = localStorage.getItem('partnerId');

const connectDAT = async (jsonData, xmlImageArr) => {
    // const {
    //     // vin,
    //     maker,
    //     model,
    //     nr,
    //     mileage
    // } = jsonData;

    const {
        phone,
        email,
        // nrCustomer = nr,
        street,
        company,
        city,
        zip,
        creator
    } = jsonData;
    const {Vin,Make,Model,KilometerReading,kilometerStand,RegNo} = jsonData
    var d = new Date();
    // var n = d.getSeconds();
    let newOrderXML = ''
    
    newOrderXML = await axios.get("/DAT/newOrderHZD.xml");


    let xmlString = '';
    let parser = new DOMParser();
    let xml = parser.parseFromString(xmlString, 'text/xml');

    let fragment = xml.createDocumentFragment();

    let attachmentsElement = xml.createElement('ns2:Attachments');

    xmlImageArr.map(newImg => {
        let fileName = newImg.file_name || '';
        let imageBase64 = newImg.base64 || '';
        let length = newImg.length;

        // Create <ns2:Attachment> element without explicit namespace URI
        let attachment = xml.createElement('ns2:Attachment');

        // Create child elements
        let attachmentType = xml.createElement('ns2:AttachmentType');
        attachmentType.textContent = 'image';
        attachment.appendChild(attachmentType);

        let folderIdElement = xml.createElement('ns2:FolderId');
        attachment.appendChild(folderIdElement);

        let sourceElement = xml.createElement('ns2:Source');
        sourceElement.textContent = 'dat';
        attachment.appendChild(sourceElement);

        let suffixElement = xml.createElement('ns2:suffix');
        suffixElement.textContent = '';
        attachment.appendChild(suffixElement);

        let versionElement = xml.createElement('ns2:version');
        versionElement.textContent = '';
        attachment.appendChild(versionElement);

        let filenameElement = xml.createElement('ns2:filename');
        filenameElement.textContent = fileName;
        attachment.appendChild(filenameElement);

        let filenameShortElement = xml.createElement('ns2:filenameShort');
        filenameShortElement.textContent = fileName;
        attachment.appendChild(filenameShortElement);

        let offsetElement = xml.createElement('ns2:offset');
        offsetElement.textContent = '1';
        attachment.appendChild(offsetElement);

        let lengthElement = xml.createElement('ns2:length');
        lengthElement.textContent = length.toString();
        attachment.appendChild(lengthElement);

        let descriptionElement = xml.createElement('ns2:description');
        descriptionElement.textContent = '';
        attachment.appendChild(descriptionElement);

        let b64DataElement = xml.createElement('ns2:b64Data');
        b64DataElement.textContent = imageBase64;
        attachment.appendChild(b64DataElement);

        attachmentsElement.appendChild(attachment);
    });

    fragment.appendChild(attachmentsElement);

    let xmlSerializer = new XMLSerializer();
    let encodedXmlString = xmlSerializer.serializeToString(fragment);

    newOrderXML = newOrderXML.data.replace(
        "<ns2:Name/>",
        "<ns2:Name>" + Vin.split("_")[0] + "</ns2:Name>"
    );
    // "<ns2:Name>" + Vin.split("_")[0] + "" + n + "</ns2:Name>"

    newOrderXML = newOrderXML.replace(
        "<ns2:Description/>",
        "<ns2:Description>" + Vin.split("_")[0] + "</ns2:Description>"
    );

    newOrderXML = newOrderXML.replaceAll(
        "<ns2:VehicleIdentNumber/>",
        "<ns2:VehicleIdentNumber>" + Vin.split("_")[0] + "</ns2:VehicleIdentNumber>"
    );

    newOrderXML = newOrderXML.replace(
        "<networkType/>",
        "<networkType>DAT</networkType>"
    )
    //     newOrderXML = newOrderXML.replace(
    //       "<ns2:VatAtCalculationTime/>",
    //       "<ns2:VatAtCalculationTime>19.0</ns2:VatAtCalculationTime>"
    //     )
    newOrderXML = newOrderXML.replace(
        "<Country/>",
        "<ns2:Country>DE</ns2:Country>"
    )
    newOrderXML = newOrderXML.replace(
        "<Language/>",
        "<ns2:Language>de_DE</ns2:Language>"
    )

    newOrderXML = newOrderXML.replace(
        "</ns2:Owner/>",
        ""
    );

    newOrderXML = newOrderXML.replaceAll(
        "<ns2:PhoneBusiness/>",
        `<ns2:PhoneBusiness>${phone}</ns2:PhoneBusiness>`
    );

    newOrderXML = newOrderXML.replaceAll(
        "<ns2:LicenseNumber/>",
        "<ns2:LicenseNumber>" + RegNo + "</ns2:LicenseNumber>"
    );

    newOrderXML = newOrderXML.replaceAll(
        "<ns2:MileageOdometer/>",
        "<ns2:MileageOdometer>" + kilometerStand + "</ns2:MileageOdometer>"
    );


    newOrderXML = newOrderXML.replaceAll(
        "<ns2:ManufacturerName />",
        `<ns2:ManufacturerName origin="dat">${Make}</ns2:ManufacturerName>`
    );
    newOrderXML = newOrderXML.replaceAll(
        "<ns2:BaseModelName />",
        `<ns2:BaseModelName origin="dat">${Model}</ns2:BaseModelName>`
    );

    newOrderXML = newOrderXML.replaceAll(
        "<ns2:CompanyName />",
        `<ns2:CompanyName>${company}</ns2:CompanyName>`
    );

    newOrderXML = newOrderXML.replaceAll(
        "<ns2:NameLong />",
        `<ns2:NameLong>${company}</ns2:NameLong>`
    );

    newOrderXML = newOrderXML.replaceAll("<ns2:Street />", `<ns2:Street>${street}</ns2:Street>`)
    // newOrderXML = newOrderXML.replaceAll("<ns2:StreetNumber />", `<ns2:StreetNumber>${nrCustomer}</ns2:StreetNumber>`)
    newOrderXML = newOrderXML.replaceAll("<ns2:StreetZipCode />", `<ns2:StreetZipCode>${zip}</ns2:StreetZipCode>`)
    newOrderXML = newOrderXML.replaceAll("<ns2:StreetCity />", `<ns2:StreetCity>${city}</ns2:StreetCity>`)

    if(xmlImageArr.length > 0){
        newOrderXML = newOrderXML.replace(
            "</ns2:Attachments>",
            encodedXmlString  
        )
    } else {
        newOrderXML = newOrderXML.replace(
            "</ns2:Attachments>",
             ''
        )
    }

    var repairPositionsXml = await repairPositions(jsonData);

    var finalXML = newOrderXML.replace(
        "<ns2:RepairPositions/>",
        repairPositionsXml
    );

    return await sendToDAT(finalXML).then((status) =>  {
        return status;
    });


}

const repairPositions = async (datJSON) => {
    const {
        Dents
    } = datJSON;
    var repairPositionXmlTemplate = `<ns2:RepairPosition>
                        <ns2:DATProcessId/>
                        <ns2:RepairType>overhaul</ns2:RepairType>
                        <ns2:PositionEntryType>dents</ns2:PositionEntryType>
                        <ns2:WorkType>other</ns2:WorkType>
                        <ns2:DentsCount/>
                        <ns2:DentsSize/>
                        <ns2:DentsPartOrientation/>
                        <ns2:DentsCalculationMethod>BVAT</ns2:DentsCalculationMethod>
                        <ns2:DentsWithFinishing>false</ns2:DentsWithFinishing>
                        <ns2:DentsWithSetupTime>false</ns2:DentsWithSetupTime>
                        <ns2:DentsWithAddLightMetals>false</ns2:DentsWithAddLightMetals>
                        <ns2:DentsOutOfReach>false</ns2:DentsOutOfReach>
                        <ns2:IsAdditionalLM>false</ns2:IsAdditionalLM>
                        <ns2:PreDamage>false</ns2:PreDamage>
                        <ns2:AlloyLM>false</ns2:AlloyLM>
                        <ns2:LargeScale>false</ns2:LargeScale>
                        <ns2:AdhesiveTechnologyScale>false</ns2:AdhesiveTechnologyScale>
                        <ns2:AdditionLM>false</ns2:AdditionLM>
                        <ns2:WorkCompleted>false</ns2:WorkCompleted>
                        <ns2:ContainMicroDents>false</ns2:ContainMicroDents>
                        <ns2:HasAluminium>false</ns2:HasAluminium>
                        <ns2:AdhesiveMethod>false</ns2:AdhesiveMethod>
                        <ns2:WorkIndication>0</ns2:WorkIndication>
                    </ns2:RepairPosition>`;
    var repairPositionXml;

    if (Dents.length) {
        const datResult = Dents;
        var trunkDentCount = 0; // For matycali there was a requirement to keep Trunk dents to 0 and add actual Trunk Dents to TrunkCover which is why this variable is used to add the dents from Trunk to TrunkCover. Logic for the same has been implemented inside map function below
        const newXML = datResult
            .map((r, i) => {
                const record = r;
                if (record.Part == "Trunk") {
                    repairPositionXml = repairPositionXmlTemplate.replace(
                        "<ns2:DATProcessId/>",
                        "<ns2:DATProcessId>" + "54040" + "</ns2:DATProcessId>"
                    );
                } else if (record.Part == "TrunkCover") {
                    repairPositionXml = repairPositionXmlTemplate.replace(
                        "<ns2:DATProcessId/>",
                        "<ns2:DATProcessId>" + "54030" + "</ns2:DATProcessId>"
                    );
                } else {
                    repairPositionXml = repairPositionXmlTemplate.replace(
                        "<ns2:DATProcessId/>",
                        "<ns2:DATProcessId>" + record.Datcode + "</ns2:DATProcessId>"
                    );
                }

                if (record.Part == "Hood" || record.Part == "TrunkCover" || record.Part == "Roof") {
                    repairPositionXml = repairPositionXml.replace(
                        "<ns2:DentsPartOrientation/>",
                        "<ns2:DentsPartOrientation>" + "V" + "</ns2:DentsPartOrientation>"
                    );
                } else {
                    repairPositionXml = repairPositionXml.replace(
                        "<ns2:DentsPartOrientation/>",
                        "<ns2:DentsPartOrientation>" + "S" + "</ns2:DentsPartOrientation>"
                    );
                }

                if (record.TotalDents > 0) {
                    if (record.Part == 'Trunk') {
                        repairPositionXml = repairPositionXml.replace(
                            "<ns2:DentsCount/>",
                            "<ns2:DentsCount>" + 0 + "</ns2:DentsCount>"
                        );
                        trunkDentCount = record.TotalDents;
                    } else {
                        if (record.Part == 'TrunkCover') {
                            var totalDents = record.TotalDents + trunkDentCount;
                            repairPositionXml = repairPositionXml.replace(
                                "<ns2:DentsCount/>",
                                "<ns2:DentsCount>" + totalDents + "</ns2:DentsCount>"
                            );
                        } else {
                            repairPositionXml = repairPositionXml.replace(
                                "<ns2:DentsCount/>",
                                "<ns2:DentsCount>" + record.TotalDents + "</ns2:DentsCount>"
                            );
                        }
                    }
                }

                repairPositionXml = repairPositionXml.replace(
                    "<ns2:DentsSize/>",
                    "<ns2:DentsSize>" + record.AvgDiaMm + "</ns2:DentsSize>"
                );

                return repairPositionXml;
            })
            .join("");
        return "<ns2:RepairPositions>" + newXML + "</ns2:RepairPositions>";
    } else {
        alert("No dent file");
    }
};


const getData = async (vin) => {
    const [partnerId] = [ localStorage.getItem('partnerId')]
    let Dents = await axios.get(`${configuration.getData}?vin=${vin}&partnerId=${partnerId}`)
        .then((res) => {
            if (res && res.data && res.data.Dents) {
                return res.data;
            } else {
                return [];
            }
        })
    return Dents;
}

export const getDATUser = () => {
    let url = `${window.location.origin}/userDAT.json`;
    return axios.get(url)
      .then((r) => {
        return r.data; // Return the data received from the response
      })
      .catch((e) => {
        console.error(e, "error"); // Log the error
        throw e; // Rethrow the error
      });
};  

const sendToDAT = async (finalXML) => {
    const datUserData = await getDATUser()
    const partnerId = localStorage.getItem("partnerId");
    const config = datUserData[partnerId] || datUserData.default;

    finalXML = finalXML.replaceAll("<ns2:CustomerNumber/>", `<ns2:CustomerNumber>${config.customerNumber}</ns2:CustomerNumber>`);
    finalXML = finalXML.replaceAll("<ns2:CustomerType/>", `<ns2:CustomerType>${config.customerNumber}</ns2:CustomerType>`);

    return new Promise((resolve, reject) => {
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.open(
            "POST",
            "https://www.dat.de/myClaim/soap/v2/MyClaimExternalService",
            true
        );
    
        xmlhttp.onreadystatechange = () => {
            if (xmlhttp.readyState == 4) {
                if (xmlhttp.status == 200) {
                    var res = convert.xml2json(xmlhttp.responseText, {
                        compact: true,
                        ignoreComment: true,
                        spaces: 4,
                        trim: true,
                    });
                    const responseJson = JSON.parse(res);
                    const claimIdRespObj =
                        responseJson &&
                        responseJson["S:Envelope"] &&
                        responseJson["S:Envelope"]["S:Body"] &&
                        (responseJson["S:Envelope"]["S:Body"][
                                "ns3:createOrUpdateContractResponse"
                            ] ||
                            responseJson["S:Envelope"]["S:Body"][
                                "ns4:createOrUpdateContractResponse"
                            ] ||
                            responseJson["S:Envelope"]["S:Body"][
                                "ns5:createOrUpdateContractResponse"
                            ] ||
                            responseJson["S:Envelope"]["S:Body"][
                                "ns7:createOrUpdateContractResponse"
                            ]);
                    if (claimIdRespObj) {
                        const claimId =
                            claimIdRespObj["return"] && claimIdRespObj["return"]._text;
                        const claim = window.confirm(
                            "ClaimId Generated(" + claimId + "),Do you want to open Dat?"
                        );
    
                        if (claim) {
                            const lnk = `https://www.dat.de/myClaim/inbox.jsp?rnd=67644#claim?subView=vro_calculation&claim=${claimId}`;
                            window.open(lnk, "_blank");
                        }
                        resolve(true)
                    }
                } else {
                    resolve(false)
                    alert("Failed to call API.");
                }
            }
        };

        xmlhttp.setRequestHeader("Content-Type", "text/xml");
        xmlhttp.setRequestHeader("customerNumber", config.customerNumber);
        xmlhttp.setRequestHeader("customerLogin", config.customerLogin);
        xmlhttp.setRequestHeader("customerSignature", config.customerSignature);
        xmlhttp.setRequestHeader("interfacePartnerNumber", "1333360");
        xmlhttp.setRequestHeader("interfacePartnerSignature", "9EE76520EAFCA3CBC61D1577BA1E8024A63792EE20FC15C27ABE45487F0DF4B9");
        xmlhttp.setRequestHeader("DAT-ProductVariant", "myclaim.pro");
    
        xmlhttp.send(finalXML);

        // ----client HZD old code----

        // xmlhttp.setRequestHeader("Content-Type", "text/xml");
        // xmlhttp.setRequestHeader("customerNumber", "1333463");
        // xmlhttp.setRequestHeader("customerLogin", "d.horstkamp");
        // xmlhttp.setRequestHeader(
        //     "customerSignature",
        //     "4FCDDDE5EF87053A65BBF200D1F2505722F0C451D73FF1CA5DC233EF5FAEDF7D"
        // );
        // xmlhttp.setRequestHeader("interfacePartnerNumber", "1333360");
        // xmlhttp.setRequestHeader(
        //     "interfacePartnerSignature",
        //     "9EE76520EAFCA3CBC61D1577BA1E8024A63792EE20FC15C27ABE45487F0DF4B9"
        // );
        // xmlhttp.setRequestHeader("DAT-ProductVariant", "myclaim.pro");
        // finalXML = finalXML.replaceAll('<ns2:CustomerNumber/>', '<ns2:CustomerNumber>1333463</ns2:CustomerNumber>')
        // finalXML = finalXML.replaceAll('<ns2:CustomerType/>', '<ns2:CustomerType>1333463</ns2:CustomerType>')
        // xmlhttp.send(finalXML);
    })
};

const importDatHZD = async (datJSON, xmlImageArr) => {
    let JSONData = await getData(datJSON.vin)
    let datStatus = await connectDAT(JSONData, xmlImageArr);
    return datStatus;
}

export default importDatHZD;